import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../firebase";

// Cuentas con membresía de cortesía (sin pago); mantener igual que en firestore.rules
const COMPLIMENTARY_EMAILS = ["juli.dapur@gmail.com"];

// Estado de la membresía del usuario en tiempo real (lo escriben sólo las Cloud Functions)
const useMembership = () => {
  const [user, authLoading] = useAuthState(auth);
  const [membership, setMembership] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return undefined;
    if (!user) {
      setMembership(null);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    return onSnapshot(
      doc(db, "memberships", user.uid),
      (snapshot) => {
        setMembership(snapshot.exists() ? snapshot.data() : null);
        setLoading(false);
      },
      () => {
        setMembership(null);
        setLoading(false);
      }
    );
  }, [user, authLoading]);

  const isComplimentary =
    !!user?.emailVerified && COMPLIMENTARY_EMAILS.includes((user.email || "").toLowerCase());
  const validUntil = membership?.validUntil?.toDate?.() || null;
  const isActive = isComplimentary || (!!validUntil && validUntil.getTime() > Date.now());

  return { loading, membership, isActive, isComplimentary, validUntil };
};

export default useMembership;
